var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationsIl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.35868 372.6088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#f0f0f0;}.cls-3{fill:#f5f5f5;}.cls-10,.cls-12,.cls-14,.cls-4{fill:#fff;}.cls-5{fill:#e0e0e0;}.cls-6{fill:#407bff;}.cls-10,.cls-12,.cls-14,.cls-7{isolation:isolate;}.cls-14,.cls-7{opacity:0.2;}.cls-8{fill:#263238;}.cls-9{fill:#ffc3bd;}.cls-10{opacity:0.4;}.cls-11{fill:#b55b52;}.cls-12{opacity:0.8;}.cls-13{fill:#ed847e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 327.14412,
    y: 334.57391,
    width: 97.01079,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 270.93765,
    y: 331.67794,
    width: 26.55956,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 317.03163,
    y: 344.48415,
    width: 41.18021,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.00002,
    y: 342.69101,
    width: 24.15921,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.66094,
    y: 342.69101,
    width: 28.69593,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.30881,
    y: 338.18503,
    width: 49.98595,
    height: 0.2668
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.00002,
    y: 42.22647,
    width: 127.59107,
    height: 282.18386
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 42.22647,
    width: 121.54355,
    height: 282.18386
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.40281,
    y: 48.62997,
    width: 108.73781,
    height: 269.37712
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.52041,
    y: 169.98058,
    width: 27.86608,
    height: 5.69179,
    rx: 2.84589
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.40281,
    y: 48.62998,
    width: 1.66056,
    height: 269.37713
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 187.36396,
    y: 236.67373,
    width: 18.99634,
    height: 82.38614
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.0309,
    y: 319.05987,
    width: 93.68196,
    height: 5.22018
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.38346,
    y: 236.67375,
    width: 81.9805,
    height: 82.38612
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.85204,
    y: 246.81426,
    width: 67.04338,
    height: 27.01962
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.85204,
    y: 281.89913,
    width: 67.04338,
    height: 27.01962
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.93319,249.09228h-15.0529a1.85267,1.85267,0,0,1-1.85267-1.85267h0a1.85267,1.85267,0,0,1,1.85267-1.85267h15.0529a1.85267,1.85267,0,0,1,1.85267,1.85267h0A1.85267,1.85267,0,0,1,177.93319,249.09228Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.93319,284.17715h-15.0529a1.85267,1.85267,0,0,1-1.85267-1.85267h0a1.85267,1.85267,0,0,1,1.85267-1.85267h15.0529a1.85267,1.85267,0,0,1,1.85267,1.85267h0A1.85267,1.85267,0,0,1,177.93319,284.17715Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.65409,189.43042h0a1.40613,1.40613,0,0,1,1.40612,1.40612v42.80967a1.40613,1.40613,0,0,1-1.40612,1.40612h0a1.40613,1.40613,0,0,1-1.40612-1.40612V190.83654A1.40613,1.40613,0,0,1,176.65409,189.43042Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 139.4413,
    y: 233.39191,
    width: 26.35952,
    height: 3.32087
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.95726,186.63511h0a.70307.70307,0,0,1,.70307.70306v21.4049a.70307.70307,0,0,1-.70307.70306h0a.70307.70307,0,0,1-.70306-.70306v-21.4049A.70307.70307,0,0,1,183.95726,186.63511Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.15933,194.74266s.52105-20.14773,20.49522-20.14773,20.49521,20.14773,20.49521,20.14773Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.09812,223.24615v.00723c.569-.0001,1.14085.01215,1.71819.05143a24.49616,24.49616,0,0,1,21.92871,30.797,122.59078,122.59078,0,0,0-3.8392,31.89715v31.31908a4.11167,4.11167,0,0,1-4.11167,4.11161H245.3808V223.24615Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.89515,247.73183a24.48664,24.48664,0,1,1,48.13265,6.37,122.59028,122.59028,0,0,0-3.8392,31.89712V317.318a4.11162,4.11162,0,0,1-4.1116,4.11164H229.6847a4.11163,4.11163,0,0,1-4.11162-4.11164h0V284.15993a111.79257,111.79257,0,0,0-3.7918-29.88449A24.46,24.46,0,0,1,220.89515,247.73183Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 255.08818,
    y: 261.81678,
    width: 89.23189,
    height: 59.61289
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M442.1038,275.29444H322.67V183.85819a18.53184,18.53184,0,0,1,18.53186-18.53182h82.37008a18.53185,18.53185,0,0,1,18.53183,18.53185h0v91.43622h0Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.77154,275.29444H299.33777V182.96519a17.63886,17.63886,0,0,1,17.63886-17.63889h84.15609a17.63886,17.63886,0,0,1,17.63889,17.63886v92.32928h-.00007Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.51332,280.651H280.26593a5.37812,5.37812,0,0,1-5.37814-5.3781V261.752a5.37812,5.37812,0,0,1,5.3781-5.37814h82.24743a1.60637,1.60637,0,0,1,1.60639,1.60635v21.06444a1.60637,1.60637,0,0,1-1.60635,1.60638Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M450.90325,223.24615v.00723c.569-.0001,1.14085.01215,1.71819.05143a24.49621,24.49621,0,0,1,21.92871,30.797A122.59035,122.59035,0,0,0,470.711,285.999v31.31908a4.11171,4.11171,0,0,1-4.11167,4.11161H367.186V223.24615Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.70028,247.73183a24.48664,24.48664,0,1,1,48.13265,6.37,122.58985,122.58985,0,0,0-3.8392,31.89712V317.318a4.11162,4.11162,0,0,1-4.11161,4.11164H351.48989a4.11162,4.11162,0,0,1-4.11164-4.11161V284.15993a111.79136,111.79136,0,0,0-3.79181-29.88449A24.45917,24.45917,0,0,1,342.70028,247.73183Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M449.15613,324.41036H247.12824a2.9807,2.9807,0,0,1-2.98072-2.98072H452.13675A2.98075,2.98075,0,0,1,449.15613,324.41036Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 342.75342,
    y: 24.58693,
    width: 64.98233,
    height: 70.87753
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 338.86566,
    y: 24.58693,
    width: 66.67268,
    height: 70.87753
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 344.45126,
    y: 30.17246,
    width: 55.50155,
    height: 59.70653
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "372.202 44.932 387.381 71.223 357.023 71.223 372.202 44.932"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.59346,
    y: 65.95999,
    width: 64.98233,
    height: 70.87753
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 247.70561,
    y: 65.95999,
    width: 66.67268,
    height: 70.87753
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.29124,
    y: 71.54553,
    width: 55.50156,
    height: 59.70653
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.28294,112.04634l-6.584-11.40384A7.84289,7.84289,0,0,1,298.491,88.87819h13.168a7.84289,7.84289,0,0,1,6.79214,11.76431l-6.584,11.40384a7.84286,7.84286,0,0,1-13.58425,0Z",
    transform: "translate(-24.03302)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": " Path ",
    className: "cls-3",
    cx: 210.81833,
    cy: 360.52434,
    rx: 206.92077,
    ry: 12.08446
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Checklist"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.783 22.281 35.773 22.281 51.968 357.322 297.979 357.322 281.783 22.281"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "281.783 22.281 35.773 22.281 51.968 357.322 297.979 357.322 281.783 22.281"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "284.061 22.281 38.05 22.281 54.245 357.322 300.256 357.322 284.061 22.281"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "271.069 33.551 49.299 33.551 64.794 342.18 257.636 341.923 289.682 313.51 271.069 33.551"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.80523,33.54807a2513.36095,2513.36095,0,0,0,22.30019,276.2522q-26.35892,18.1326-52.45328,36.25474H100.83985A2517.47271,2517.47271,0,0,1,73.33159,33.54807Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.10542,309.80027q-26.35892,18.1326-52.45328,36.25474,5.70927-24.00673,11.882-48.03351Q298.80621,303.91211,319.10542,309.80027Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.47877,61.78357q.61956,16.953,1.471,33.91249h-33.913q-.85169-16.96048-1.471-33.91249h33.913m3.454-3.5759q-20.538-.00076-41.07656,0Q96.577,78.73409,97.6368,99.273h41.07655q-1.05975-20.53763-1.7806-41.0653Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.01025,74.51334H155.87059q-.16035-3.8323-.30762-7.66308,58.06992-.00078,116.13967,0Q271.85062,70.68255,272.01025,74.51334Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.47415,90.62689q-45.44034.00078-90.88,0-.1855-3.83228-.35722-7.66456h90.88Q247.28959,86.79386,247.47415,90.62689Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.79354,128.20785q1.07326,16.96573,2.3778,33.93451H105.25857q-1.30488-16.96877-2.37774-33.93451,16.95633-.00074,33.91279,0m3.35809-3.57836H99.07535q1.26962,20.54216,2.87948,41.09181,20.53768.00078,41.07631,0-1.609-20.54816-2.87948-41.09181Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.1921,140.9471H159.52594q-.2617-3.83377-.51245-7.66858h42.66615Q201.92975,137.11306,202.1921,140.9471Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.60581,140.9471H211.22193q-.26209-3.83377-.51271-7.66858h31.38416Q242.34346,137.11306,242.60581,140.9471Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.3108,157.07016H160.68034q-.28721-3.8338-.562-7.66857H261.74882Q262.02367,153.23539,262.3108,157.07016Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.88489,194.66564q1.52662,16.96877,3.28415,33.937-16.95673.00074-33.913,0-1.75809-16.968-3.28414-33.937h33.913m3.26224-3.57943H104.07057q1.81915,20.54814,3.977,41.09533H149.1241q-2.15866-20.5474-3.97695-41.09533Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.915,215.86188H165.77534q.37807,3.8353.76711,7.66908H282.6821Q282.29323,219.69644,281.915,215.86188Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.12,199.73782q-45.44037.00074-90.88,0,.35289,3.8338.71709,7.66909,45.43961-.00074,90.88,0Q255.47212,203.57239,255.12,199.73782Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.75052,261.1204q1.97967,16.96428,4.19005,33.92253h-33.913q-2.211-16.959-4.19-33.92253,16.95709-.00074,33.913,0m3.16675-3.57835H110.8407q2.36707,20.54291,5.07385,41.0778H156.9911q-2.70667-20.53314-5.07383-41.0778Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.3031,273.85718q-58.07032-.00074-116.13967,0-.46725-3.83228-.92234-7.66658H287.38076Q287.83568,270.02361,288.3031,273.85718Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.04763,289.97374h-52.8691q-.49161-3.83154-.97133-7.66557h52.86908Q226.55589,286.13967,227.04763,289.97374Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M258.62213,289.97374h-22.8294q-.492-3.83154-.97133-7.66557h22.82937Q258.13119,286.13967,258.62213,289.97374Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.491,90.856q-.75291-1.1984-1.50408-2.39577c-3.28076-5.22527-9.99054-9.89475-12.2992-11.25448q.85885-1.53081,1.71945-3.06212a48.41063,48.41063,0,0,1,12.02646,10.31947c5.16475-7.03972,12.79681-14.30062,23.25618-22.12024q1.10562,1.44453,2.21384,2.89054c-11.1676,8.35293-18.98052,16.01-23.90792,23.37087Q119.24277,89.73063,118.491,90.856Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.58346,157.29928q-.78558-1.19837-1.5679-2.39677c-3.41749-5.22933-10.254-9.90276-12.60063-11.26148q.81794-1.53156,1.63758-3.06412a50.3332,50.3332,0,0,1,12.30262,10.326c4.97519-7.04474,12.41468-14.3046,22.664-22.13524q1.1458,1.44523,2.29171,2.893c-10.94111,8.36845-18.55529,16.01651-23.28275,23.38542Q123.30483,156.17319,122.58346,157.29928Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.46764,223.91915q-.81555-1.19769-1.63194-2.39677c-3.55727-5.22776-10.5208-9.90027-12.90208-11.262q.77667-1.53159,1.55578-3.06461a52.44327,52.44327,0,0,1,12.57883,10.32747c4.78915-7.04373,12.03191-14.30659,22.07133-22.13822q1.1834,1.44678,2.36879,2.89353c-10.71809,8.36645-18.12636,16.02153-22.65633,23.388Q129.15945,222.79276,128.46764,223.91915Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.05434,327.67473c-6.297-.003-9.92659-2.32723-13.12558-4.37681-3.06008-1.965-5.94837-3.81207-11.26681-3.815-5.31956.00049-7.68735,1.85248-10.19109,3.815-2.6168,2.04958-5.58343,4.38081-11.87694,4.37681-6.2927-.003-9.92784-2.32723-13.12383-4.37681-3.06107-1.965-5.94387-3.81207-11.26556-3.815-5.31981.00049-7.68661,1.85248-10.18859,3.815-2.61709,2.04958-5.58169,4.38081-11.87494,4.37681-6.296-.003-9.92357-2.32723-13.12358-4.37681-3.06107-1.965-5.94786-3.81207-11.26506-3.815q-.21556-1.53609-.42909-3.07214c6.29372.003,9.91517,2.32323,13.11209,4.37733,3.05656,1.95856,5.94733,3.81751,11.26656,3.81452,5.31792.0025,7.68049-1.85548,10.18712-3.81452,2.61928-2.05108,5.59013-4.37632,11.88643-4.37733,6.29346.003,9.91142,2.32323,13.11258,4.37733,3.05482,1.95856,5.94959,3.81751,11.26681,3.81452,5.31992.0025,7.68146-1.85548,10.18959-3.81452,2.61753-2.05108,5.59338-4.37632,11.88843-4.37733,6.29441.003,9.91492,2.32323,13.11359,4.37733,3.05581,1.95856,5.94757,3.81751,11.26879,3.81452Q235.83342,326.13946,236.05434,327.67473Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.08224,30.57208C241.48213,21.00754,233.1467,14.6666,224.1743,14.6666H205.91035a6.94918,6.94918,0,0,1-6.35358-4.221A17.044,17.044,0,0,0,184.01133.00083a15.11864,15.11864,0,0,0-14.5356,10.4448,6.168,6.168,0,0,1-5.94543,4.221H145.26647c-8.9727,0-16.69512,6.34094-19.37057,15.90548l-1.06878,3.82009H246.52031Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.74013,38.14264H125.96988a3.99008,3.99008,0,0,1-3.93175-3.75046h0a3.55013,3.55013,0,0,1,3.34405-3.74488q.11243-.00636.22513-.00558H245.37754a3.99006,3.99006,0,0,1,3.93173,3.75046h0a3.55015,3.55015,0,0,1-3.34406,3.74488Q245.8528,38.14342,245.74013,38.14264Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.74013,38.14264H125.96988a3.99008,3.99008,0,0,1-3.93175-3.75046h0a3.55013,3.55013,0,0,1,3.34405-3.74488q.11243-.00636.22513-.00558H245.37754a3.99006,3.99006,0,0,1,3.93173,3.75046h0a3.55015,3.55015,0,0,1-3.34406,3.74488Q245.8528,38.14342,245.74013,38.14264Z",
    transform: "translate(-24.03302)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "329.189 354.115 321.37 354.115 320.591 336.008 328.411 336.008 329.189 354.115"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "376.137 354.115 368.317 354.115 364.388 336.008 372.206 336.008 376.137 354.115"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.79488,353.20958h8.78449a.682.682,0,0,1,.66577.534l1.54451,6.95023a1.14964,1.14964,0,0,1-1.14482,1.39049c-3.06677-.05273-4.55669-.23254-8.41983-.23254-2.3766,0-7.27318.24694-10.55516.24694-3.21,0-3.71068-3.24528-2.367-3.53918,6.02456-1.31789,8.294-3.13536,10.22274-4.86915A1.89662,1.89662,0,0,1,391.79488,353.20958Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M345.45474,353.20958h8.539a.682.682,0,0,1,.66577.534l1.54454,6.95023a1.13753,1.13753,0,0,1-1.12483,1.39085c-3.08028-.05231-7.53132-.2329-11.40286-.2329-4.52685,0-8.43643.24694-13.74523.24694-3.21,0-4.10092-3.24528-2.75727-3.53918,6.11689-1.33809,11.1114-1.48152,16.39731-4.74073A3.61966,3.61966,0,0,1,345.45474,353.20958Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M360.73585,68.8387c-1.12143,5.72032-1.67842,12.81,2.32372,16.627,0,0-2.29877,5.80262-12.9278,5.80262-9.71293,0-4.85049-5.80195-4.85049-5.80195,6.37872-1.52334,6.04612-9.41163,4.935-13.85618Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.272,86.26377c.22235-1.42294,2.71249-3.06823,5.55841-3.69076s13.74035-2.001,17.07538-.62255-.57806,5.45942-.57806,5.45942Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M342.272,86.26377c.22235-1.42294,2.71249-3.06823,5.55841-3.69076s13.74035-2.001,17.07538-.62255-.57806,5.45942-.57806,5.45942Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "320.594 336.012 320.993 345.346 328.815 345.346 328.415 336.012 320.594 336.012"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "372.209 336.012 364.387 336.012 366.416 345.346 374.239 345.346 372.209 336.012"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.299,92.50905l-9.42154,6.31636s13.53324,24.061,12.39708,27.91712c-1.54616,5.24754-3.70381,16.72884-6.63672,22.552.38141,1.2552,2.33384,4.12665,3.42209,4.62517,7.45111-5.68384,15.022-23.4972,14.73757-28.46353C393.14915,114.133,379.299,92.50905,379.299,92.50905Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M375.63777,149.29457l-7.43769-.57614,3.91323,8.23067s6.51915.28807,7.6089-4.6948Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "388.531 189.422 387.899 190.602 383.669 198.598 233.648 119.268 238.494 110.094 388.531 189.422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "398.235 171.095 395.138 176.949 393.386 180.254 243.35 100.927 248.196 91.753 398.235 171.095"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 334.78581,
    y: 60.31854,
    width: 10.37421,
    height: 169.71551,
    transform: "translate(28.5327 377.67327) rotate(-62.0946)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 334.78626,
    y: 60.31568,
    width: 10.37437,
    height: 169.71668,
    transform: "matrix(0.46801, -0.88372, 0.88372, 0.46801, 28.53499, 377.67253)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.181 92.969 222.816 101.224 233.646 119.273 248.196 91.757 227.181 92.969"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "227.181 92.969 222.816 101.224 233.646 119.273 248.196 91.757 227.181 92.969"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "218.174 93.487 222.816 101.224 227.181 92.969 218.174 93.487"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "338.121 152.467 342.031 159.747 348.081 156.949 344.167 148.719 338.121 152.467"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M377.05968,87.23354c7.39792,1.076,15.87035,26.71087,15.87035,26.71087l-15.53753,8.77618s-6.843-12.19247-10.21762-21.24622C363.63916,91.98813,369.125,86.0795,377.05968,87.23354Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M372.75615,96.01823c-3.36161-3.074-1.302,10.08484.29882,18.50529.82174,1.64349,1.60082,3.13753,2.26261,4.38609C379.06325,112.29321,377.38791,100.25477,372.75615,96.01823Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.25424,87.63653s-9.22863,23.61176-.463,67.58413h41.82213c.28808-6.41993-3.74572-37.73766,2.44627-67.98712a109.07914,109.07914,0,0,0-14.00008-1.76785,153.53363,153.53363,0,0,0-17.77825.00067A78.48466,78.48466,0,0,0,333.25424,87.63653Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.69666,98.61238l-10.54581-4.17707S317.01,119.22808,313.18974,120.47942c-5.19882,1.70287-15.87852,6.43776-22.338,7.325-.81744,1.02605-2.075,4.26268-1.86834,5.44172,8.90728,2.913,27.87231-.955,31.80126-4.006C329.74272,122.28387,339.69666,98.61238,339.69666,98.61238Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.87865,95.79416c-1.7397-4.013-5.06926-5.68832-8.58039-5.10156-1.3447,4.9197-3.618,15.731-3.24434,32.00592l2.48669,1.19488S343.85621,102.656,340.87865,95.79416Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.53893,92.98739c2.63488,6.996-10.71481,27.597-10.71481,27.597l-15.63829-8.49254a95.41488,95.41488,0,0,1,9.03629-18.30531C330.7571,85.542,339.64732,85.30971,342.53893,92.98739Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M291.19358,127.78193l-9.31511,2.01512,4.7207,8.61187a25.69726,25.69726,0,0,0,6.98684-5.09715Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "253.456 131.707 257.171 136.849 262.566 138.409 257.846 129.797 253.456 131.707"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 342.30251,
    cy: 60.56776,
    rx: 1.14192,
    ry: 0.74646,
    transform: "translate(238.0959 398.81568) rotate(-86.69967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M343.603,60.66073a22.57637,22.57637,0,0,1-3.31837,5.21156,3.6352,3.6352,0,0,0,2.97529.738Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.2409,58.4271a.36143.36143,0,0,1-.15633-.05686.36963.36963,0,0,1-.11038-.51094l.00056-.00085a3.676,3.676,0,0,1,2.89259-1.74889.37054.37054,0,0,1,.00547.741h0a2.93454,2.93454,0,0,0-2.27646,1.40978A.36981.36981,0,0,1,342.2409,58.4271Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M364.2622,60.059c-.92078,7.7054-1.06812,12.262-5.20253,16.00587-6.219,5.63144-15.55976,1.53974-16.95973-6.28546-1.26008-7.04344.45733-18.46107,8.204-21.102A10.5842,10.5842,0,0,1,364.2622,60.059Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M348.73461,61.56967c-2.69949.53361-7.00957-5.46044-3.49521-10.55354-1.78154-.88934-7.59193,2.60875-9.78563-.65218s3.88346-5.01,2.72734-7.76693c4.12141.84488-2.668,5.98534,1.24507,5.48283s8.43288-7.74216,12.851-4.77136c7.73729,5.20266,18.276-3.46844,13.97459,7.38155,5.27675-1.06721,8.88155,5.173,3.85675,9.48633-10.01579,8.5976-3.85675,9.72348-10.19778,10.16814C356.68382,70.57085,349.29349,66.75748,348.73461,61.56967Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.73923,63.557a6.51806,6.51806,0,0,1-3.72606,3.29907c-2.16549.7288-3.36686-1.17927-2.86448-3.28508.45215-1.89545,2.12374-4.55868,4.34509-4.37465a2.92672,2.92672,0,0,1,2.24545,4.36066Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.62708,155.22066s8.8737,59.75551,13.74523,82.14214c5.33466,24.51505,25.43278,106.17572,25.43278,106.17572h14.32137s-13.25263-79.68121-16.29673-103.95343c-3.30383-26.34337-10.21632-84.36443-10.21632-84.36443Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M347.62708,155.22066s8.8737,59.75551,13.74523,82.14214c5.33466,24.51505,25.43278,106.17572,25.43278,106.17572h14.32137s-13.25263-79.68121-16.29673-103.95343c-3.30383-26.34337-10.21632-84.36443-10.21632-84.36443Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M358.16644,176.11225c-.65867-.93641-1.2634-1.25689-1.81863-1.09691-.0383.01146-.07634.02553-.11438.04117a1.40625,1.40625,0,0,0-.35044.20844,2.347,2.347,0,0,0-.30667.31109q-.08555.10081-.16936.21782-.116.16182-.229.35331a8.155,8.155,0,0,0-.47967.97341q-.12463.297-.24518.629c-.09588.26419-.18916.54455-.28087.83845q-.18248.58856-.35383,1.24855-.04412.17037-.08751.345-.08912.35953-.17561.73683-.07148.31271-.1407.63626-.136.63316-.26368,1.30536-.136.7144-.26315,1.46528-.04455.26263-.08807.52944-.15672.96064-.30015,1.96142h0l.00052.00417c2.36921,14.87636,5.18624,31.92829,7.502,43.82656q.16923-.57843.32647-1.2225a55.9957,55.9957,0,0,0,1.07007-6.0286C363.378,208.05617,362.44363,182.22631,358.16644,176.11225Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.79128,155.22066s-1.07682,58.462-.22635,82.30674c.88463,24.802,9.54758,106.01109,9.54758,106.01109H355.3584s.48615-79.76,1.07549-104.118c.64245-26.55455,3.84864-84.1998,3.84864-84.1998Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M332.79128,155.22066s-1.07682,58.462-.22635,82.30674c.88463,24.802,9.54758,106.01109,9.54758,106.01109H355.3584s.48615-79.76,1.07549-104.118c.64245-26.55455,3.84864-84.1998,3.84864-84.1998Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M356.23206,339.48027c.06129,0,0,4.32815,0,4.32815H340.96443l-.64193-4.86176Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.12646,339.80638c.0613,0,.71349,4.002.71349,4.002H386.09858l-1.39329-4.595Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M389.20905,354.57469a2.37179,2.37179,0,0,1-1.50539-.39786,1.11429,1.11429,0,0,1-.38268-.97947.58778.58778,0,0,1,.31686-.52374c.85577-.4427,3.38627,1.10535,3.672,1.28331a.189.189,0,0,1,.08465.18808.186.186,0,0,1-.13963.149A9.17784,9.17784,0,0,1,389.20905,354.57469Zm-1.16179-1.61752a.53067.53067,0,0,0-.24016.04628.22543.22543,0,0,0-.11647.217.7537.7537,0,0,0,.251.67278,3.75845,3.75845,0,0,0,2.7757.14033A7.48008,7.48008,0,0,0,388.04726,352.95717Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.21144,354.29978a.18988.18988,0,0,1-.08826-.02169c-.8095-.43984-2.37348-2.15286-2.2078-3.02524a.6025.6025,0,0,1,.58956-.48469,1.00746,1.00746,0,0,1,.78852.2373c.9086.7422,1.09522,2.99922,1.10242,3.09471a.18641.18641,0,0,1-.17265.19919l-.01182.00045Zm-1.57773-3.16994c-.02748,0-.055.00289-.08393.00579-.24087.02892-.26188.14034-.27054.18662-.09839.515.89847,1.81,1.70288,2.42048a4.45781,4.45781,0,0,0-.92306-2.45087.65709.65709,0,0,0-.42538-.162Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.20256,354.57613a2.96108,2.96108,0,0,1-1.89963-.48036,1.03739,1.03739,0,0,1-.3465-.90137.58593.58593,0,0,1,.30523-.49192c.94837-.53387,4.09226,1.0634,4.44814,1.24715a.18623.18623,0,0,1-.04918.34722A13.29983,13.29983,0,0,1,342.20256,354.57613Zm-1.41494-1.619a.72883.72883,0,0,0-.34579.068.22231.22231,0,0,0-.11646.19821.67875.67875,0,0,0,.22352.59611c.48107.42681,1.768.49915,3.494.21267A10.21262,10.21262,0,0,0,340.78762,352.95717Z",
    transform: "translate(-24.03302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.6245,354.29978a.19845.19845,0,0,1-.076-.01593c-.94332-.42391-2.81328-2.11377-2.67008-2.99922.03329-.20687.18086-.46586.68942-.51654a1.33236,1.33236,0,0,1,1.02725.31687c.99464.81747,1.20517,2.92252,1.21386,3.01224a.1873.1873,0,0,1-.07666.16783A.18238.18238,0,0,1,344.6245,354.29978Zm-1.90758-3.16994c-.03618,0-.0738.00289-.11142.00579-.33347.03472-.35447.16493-.3617.20834-.08537.531,1.18491,1.85912,2.14777,2.43787a4.34213,4.34213,0,0,0-1.03158-2.41038.983.983,0,0,0-.64307-.24159Z",
    transform: "translate(-24.03302)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationsIl);
export default __webpack_public_path__ + "static/media/graduations-il.6d08f860f78d130cae950783bd18c7d9.svg";
export { ForwardRef as ReactComponent };